import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import Tabs from 'components/admin/Helper/Tabs'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import { dirname } from 'path'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { formValues, reduxForm, change } from 'redux-form'
import { confirmationModal, setDirtyFormState } from 'redux/navigation'
import { deleteProperty, saveProperty } from 'redux/properties'
import { Segment } from 'semantic-ui-react'
import Properties from './Properties'
import PropertiesValues from './PropertiesValues'

const i18nkey = 'admin.property_editor.'

const mapStateToProps = (state, ownProps) => {
  const { properties = [] } = state.properties
  const { products = [] } = state.product
  return { properties, products }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveProperty,
      push,
      confirmationModal,
      setDirtyFormState,
      deleteProperty,
    },
    dispatch
  )

const onChange = (values, dispatch, props, previousValues) => {
  if (!previousValues) return
  if (values.user_selectable && !previousValues.user_selectable) dispatch(change(props.form, 'sortable', false))
  else if (values.sortable && !previousValues.sortable) dispatch(change(props.form, 'user_selectable', false))
}

class PropertiesEdit extends React.Component {
  emptyForm = {
    name_de: '',
    name_fr: '',
    description_de: '',
    description_fr: '',
    selection: false,
    sortable: true,
    active: true,
  }

  componentWillMount() {
    const { initialize } = this.props // redux form
    const { properties } = this.props // redux
    const {
      match: {
        params: { property_id },
      },
    } = this.props // withRouter
    if (property_id === '+') {
      initialize(this.emptyForm)
    } else {
      const selectedProperty = properties.find(
        (property) => property.id === parseInt(property_id, 10)
      )
      if (selectedProperty) initialize(selectedProperty)
    }
  }

  // change the form content when currently selected property changes (by url param)
  componentWillReceiveProps(nextProps) {
    const { initialize, destroy } = this.props // redux form
    const { properties: newProperties } = nextProps // redux
    const { properties: oldProperties } = this.props //redux
    const {
      match: {
        params: { property_id: newPropertyId },
      },
    } = nextProps //withRouter
    const {
      match: {
        params: { property_id: oldPropertyId },
      },
    } = this.props //withRouter
    const newSelectedProperty = newProperties.find(
      (property) => property.id === Number(newPropertyId)
    )
    const oldSelectedProperty = oldProperties.find(
      (property) => property.id === Number(oldPropertyId)
    )

    if (
      newSelectedProperty &&
      (!oldSelectedProperty ||
        oldSelectedProperty.id !== newSelectedProperty.id)
    ) {
      initialize(newSelectedProperty)
    } else if (oldPropertyId !== '+' && newPropertyId === '+') {
      initialize(this.emptyForm)
    } else if (oldPropertyId && !newPropertyId) {
      destroy()
    }
  }

  componentDidUpdate(prevProps) {
    const { setDirtyFormState } = this.props
    if (prevProps.dirty !== this.props.dirty)
      setDirtyFormState(this.props.dirty)
  }

  saveProperty({
    id,
    name_de,
    name_fr,
    description_de,
    description_fr,
    user_selectable,
    active,
    sortable,
  }) {
    const { saveProperty, push } = this.props //redux
    const {
      location: { pathname },
      match: {
        params: { property_id },
      },
    } = this.props //router
    saveProperty({
      id,
      name_de,
      name_fr,
      description_de,
      description_fr,
      user_selectable,
      active,
      sortable,
    })
    // TODO: Handle error -> put in reducer or send path..callback?
    let basePath = pathname
    if (property_id) basePath = dirname(basePath)
    basePath = basePath.replace(/\/$/, '')
    push(basePath)
  }

  getTabs() {
    const { properties } = this.props // redux
    const {
      match: {
        params: { property_id },
      },
    } = this.props // withRouter
    const selectedProperty = properties.find(
      (property) => property.id === parseInt(property_id, 10)
    )
    let tabs = ['properties']
    if (selectedProperty) tabs.push('values')
    const definedTabs = {
      properties: {
        title: I18n.t(i18nkey + 'tabs.properties'),
        key: 'properties',
        content: <Properties />,
      },
      values: {
        title: I18n.t(i18nkey + 'tabs.values'),
        key: 'values',
        content: <PropertiesValues selectedProperty={selectedProperty} />,
      },
    }
    return tabs.map((tab) => definedTabs[tab])
  }

  getActions() {
    // getActions
    const {
      confirmationModal,
      properties,
      deleteProperty,
      push, //connect
      match: {
        params: { property_id },
      },
      location: { pathname }, //withRouter
      handleSubmit,
      pristine,
      reset, //reduxForm
    } = this.props
    const selectedProperty =
      properties.find(
        (property) => property.id === parseInt(property_id, 10)
      ) || {}
    const { product_ids = [] } = selectedProperty

    return [
      {
        icon: 'cancel',
        secondary: true,
        content: I18n.t('global.cancel'),
        disabled: pristine,
        onClick: () => {
          confirmationModal({
            icon: config.icons.delete,
            negative: true,
            title: I18n.t('global.abortModal.title'),
            text: I18n.t('global.abortModal.text'),
            button: I18n.t('global.abortModal.button'),
            confirm: () => {
              reset()
            },
          })
        },
      },
      {
        icon: 'trash',
        color: 'red',
        labelPosition: 'left',
        content: I18n.t('global.delete'),
        disabled: product_ids && product_ids.length > 0,
        onClick: () => {
          confirmationModal({
            icon: config.icons.delete,
            negative: true,
            title: I18n.t(i18nkey + 'deleteModal.title'),
            text: I18n.t(i18nkey + 'deleteModal.text'),
            button: I18n.t(i18nkey + 'deleteModal.button'),
            confirm: () => {
              deleteProperty(selectedProperty.id)
              // TODO: Handle error -> put in reducer or send path..callback?
              let basePath = pathname
              if (property_id) basePath = dirname(basePath)
              basePath = basePath.replace(/\/$/, '')
              push(basePath)
            },
          })
        },
      },
      {
        icon: 'checkmark',
        color: 'green',
        content: 'save',
        onClick: handleSubmit((formValues) => this.saveProperty(formValues)),
      },
    ]
  }

  render() {
    const dark = config.theme.dark
    const { initialized, dirty } = this.props // redux form
    const { id, name_de } = this.props //formValues

    const componentTitle =
      (id && name_de) || I18n.t('admin.property_editor.properties.new_property')

    const segmentProps = {
      className: classNames(['payload', dark && 'inverted']),
    }

    if (!initialized) return false
    return (
      <div
        className={classNames([
          'PropertiesEdit',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        <ComponentHeader
          actions={this.getActions()}
          title={componentTitle}
          dirty={dirty}
        />

        <Segment basic attached {...segmentProps}>
          <Tabs
            tabs={this.getTabs()}
            startTab="properties"
            context="properties_edit"
          />
        </Segment>
      </div>
    )
  }
}

PropertiesEdit = connect(mapStateToProps, mapDispatchToProps)(PropertiesEdit)
PropertiesEdit = formValues('id', 'name_de')(PropertiesEdit)
PropertiesEdit = reduxForm({ form: 'property_edit', onChange })(PropertiesEdit)
export default withRouter(PropertiesEdit)



// WEBPACK FOOTER //
// ./src/components/admin/Properties/PropertiesEdit.jsx